/**
 * Stamp coach speech with the live sequence moment.
 * before: explaining, no sequence has finished yet.
 * during: a sequence or a single timed block is running.
 * after: a sequence finished and the next one has not started.
 */
export function resolveCapturePhase({
  sequenceRunning = false,
  betweenSequences = false,
  sequenceIndex = 0,
  lastSequenceCompleted = false,
} = {}) {
  if (sequenceRunning) return "during";
  const index = Number(sequenceIndex) || 0;
  if (lastSequenceCompleted) return "after";
  if (betweenSequences && index > 0) return "after";
  return "before";
}

export function captureSequenceOrder({ phase, sequenceNumber }) {
  const number = Number(sequenceNumber);
  if (!Number.isFinite(number) || number < 1) return null;
  if (phase === "after") return Math.max(1, number - 1);
  return number;
}
